import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { Type } from "discover.medical.react-component-library";
import RegimenField, {
  PRESENTATION_FIELD,
  PRESENTATION,
  getFieldPresentation,
} from "./RegimenField";
import FieldWrapper from "./FieldWrapper";
import { StyledSubRegimensWrapper } from "./_.styled";

const Regimen = ({ regimen, onClick, itemLabels }) => {
  const renderMetadata = (regimen) => (
    <Fragment key={regimen.templateId}>
      <RegimenField
        label={`${itemLabels.indications} ${regimen.displayIndications}`}
      />
      <Type>
        {itemLabels.templateId}{" "}
        <RegimenField
          display="inline"
          label={regimen.displayTemplateId}
          presentation={PRESENTATION.BOLD}
        />{" "}
        ({itemLabels.updatedDate} {regimen.updatedDate})
      </Type>
    </Fragment>
  );

  const renderSubRegimen = (subRegimen) => (
    <Fragment key={subRegimen.templateId}>
      <FieldWrapper href={subRegimen.slug} onClick={() => onClick(subRegimen)}>
        <RegimenField
          label={subRegimen.displayCourseTitle}
          presentation={PRESENTATION.BOLD_LINK}
        />
      </FieldWrapper>
      {renderMetadata(subRegimen)}
    </Fragment>
  );

  return (
    <>
      <FieldWrapper href={regimen.slug} onClick={() => onClick(regimen)}>
        <RegimenField
          label={regimen.diseaseName}
          presentation={getFieldPresentation(
            regimen,
            PRESENTATION_FIELD.DISEASE_NAME
          )}
        />
        <RegimenField
          label={regimen.displayRegimenTitle}
          presentation={getFieldPresentation(
            regimen,
            PRESENTATION_FIELD.REGIMEN_TITLE
          )}
        />
        <RegimenField
          label={regimen.displayCourseTitle}
          presentation={getFieldPresentation(
            regimen,
            PRESENTATION_FIELD.COURSE_TITLE
          )}
        />
      </FieldWrapper>
      {regimen.subRegimens?.length ? (
        <StyledSubRegimensWrapper>
          {regimen.subRegimens.map(renderSubRegimen)}
        </StyledSubRegimensWrapper>
      ) : (
        renderMetadata(regimen)
      )}
    </>
  );
};

const regimenPropTypes = {
  uuid: PropTypes.string.isRequired,
  diseaseName: PropTypes.string.isRequired,
  displayCourseTitle: PropTypes.string,
  displayIndications: PropTypes.string.isRequired,
  displayRegimenTitle: PropTypes.string.isRequired,
  displayTemplateId: PropTypes.string.isRequired,
  updatedDate: PropTypes.string,
  slug: PropTypes.string,
  relatedAgents: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    })
  ),
};

Regimen.propTypes = {
  regimen: PropTypes.shape({
    ...regimenPropTypes,
    subRegimens: PropTypes.arrayOf(PropTypes.shape(regimenPropTypes)),
  }).isRequired,
  onClick: PropTypes.func.isRequired,
  itemLabels: PropTypes.shape({
    indications: PropTypes.string.isRequired,
    templateId: PropTypes.string.isRequired,
    updatedDate: PropTypes.string.isRequired,
  }).isRequired,
};

export default Regimen;
